<template>
  <span v-if="ready">
    <b-modal v-if="showConfirmModal" v-model="showConfirmModal"
      title="Deseja realizar essa operação?"
      class="modal-primary"
      @ok="update">

       Deseja realizar essa atualização para o item <b>{{ instance.representation || '' }}</b>?
    </b-modal>

    <i :class='currentClass'
      v-b-tooltip.hover
      :title="label || ''"
      :style="`color: ${color};`"
      @click.stop.prevent="attemptUpdate"></i>
  </span>
</template>

<script>
import { clone } from 'lodash'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    field: {
      type: Object,
      required: true
    },

    values: {
      type: Array,
      default () {
        return [true, false]
      }
    },

    classes: {
      type: Array,
      default () {
        return ['fa fa-toggle-on', 'fa fa-toggle-off']
      }
    },

    colors: {
      type: Array,
      default () {
        return ['green', 'gray']
      }
    },

    labels: {
      type: Array,
      default () {
        return ['Ativo', 'Inativo']
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },

    confirm: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      processing: false,
      showConfirmModal: false
    }
  },

  computed: {
    ready () {
      return [this.colors.length, this.classes.length, this.values.length].reduce((a, b) => {
        return (a === b) ? a : NaN
      })
    },

    index () {
      return this.values.indexOf(this.instance[this.field.key])
    },

    currentClass () {
      return this.classes[this.index]
    },

    color () {
      return this.colors[this.index]
    },

    label () {
      return this.labels[this.index]
    },

    nextIndex () {
      return this.index < (this.values.length - 1) ? this.index + 1 : 0
    },

    nextValue () {
      return this.values[this.nextIndex]
    }
  },

  methods: {
    attemptUpdate () {
      if (!this.disabled) {
        if (this.confirm) {
          this.showConfirmModal = true
        } else {
          this.update()
        }
      }

      return null
    },

    update () {
      const self = this
      const payload = clone(self.instance)

      self.processing = true
      self.$Progress.start()
      self.showConfirmModal = false

      payload[self.field.key] = self.nextValue

      self.http.update(self.instance.id, payload)
        .then((res) => {
          self.$Progress.finish()
          self.processing = false
          self.instance[self.field.key] = self.nextValue
          self.$emit('refresh')
          self.$toasted.success('Atualização realizada com sucesso')
        }).catch(() => {
          self.$Progress.fail()
          self.processing = false
          self.$toasted.error('Atualização não foi realizada. Verifique se a operação é permitida.')
        })
    }
  }
}
</script>

<style lang="sass" scoped>
i
  cursor: pointer
  margin-right: 8px
</style>



// WEBPACK FOOTER //
// src/components/ui/DatatableElements/ToggleOptionElement.vue